module.exports = __webpack_public_path__ + "img/logo-menu.97ef4672.svg";